<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <!-- panneau gauche -->
  <wiz-vgroup width="300px" minWidth="0px" maxWidth="300px" height="100%">
    <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnMassExport [wizTooltip]="'$.common.massexport.$'" class="image-purple"
          (click)="doAct('massExport')">settings</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnMassImport [wizTooltip]="'$.common.massimport.$'" class="image-purple"
          (click)="doAct('massImport')">settings</wiz-icon>
        <wiz-icon #btnRemove class="image-purple" [wizTooltip]="'$.common.delete.$'"
          (click)="doAct('delete')">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-vgroup target="title">
        <wiz-hgroup verticalAlign="center" gap="10" padding="0 0 10px">
          <wiz-icon #btnAddVision [wizTooltip]="'$.vision.add.$'" tooltipPlacement="right" class="image-back-orange" (click)="doAct('create')">add</wiz-icon>
          <wiz-label class="titleLabel" [wizLabel]="'$.vision.add.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
        </wiz-hgroup>
      </wiz-vgroup>

    </multi-display>
  </wiz-vgroup>

  <!-- zone détail -->
  <wiz-group width="100%" height="100%" class="section-container-parent">
    <!-- lorsque rien n'est sélectionné -->
    <!-- <widget-renderer
      *ngIf="!isDetailVisible"
      class="view-widget"
      width="100%"
      [title]="'$.vision.home.title.$'"
      [description]="'$.vision.home.description.$'"
    ></widget-renderer> -->

    <!-- zone détail -->
    <wiz-vgroup wizValidationContainer #vgDetailZone [visible]="isDetailVisible" width="100%" height="100%">
      
      <!-- header -->
      <wiz-hgroup
        wizValidationContainer
        padding="5px"
        width="100%"
        class="section-container"
        horizontalAlign="space-between">
           
      <wiz-hgroup wizValidationContainer style="overflow: auto !important;">

        <!-- code, libellé, image & description -->
        <wiz-vgroup width="330px" [verticalAlign]="'center'" gap="10" wizValidationContainer>
          <wiz-hgroup [verticalAlign]="'center'" gap="10" wizValidationContainer>
              <wiz-text-input
                #tiCode id="tiCode"
                class="upper-case-input"
                width="120px"
                [wizLabel]="'$.common.code.$'"
                [wizValidator]="uniqueCodeValidator()"
                [wizShowErrors]="true"
                [wizMandatory]="true"
                [wizMaxChars]="50"
                [wizPlaceholder]="'$.common.define.$'"
              ></wiz-text-input>
              <wiz-translation
                #tiLabelTrs
                width="200px"
                [wizLabel]="'$.common.label.$'"
                [wizMandatory]="true"
                [wizPlaceholder]="'$.common.define.$'"
                [wizMaxChars]="100"
                [wizShowErrors]="true"
              ></wiz-translation>
          </wiz-hgroup>
          <wiz-hgroup width="100%" gap="5" wizValidationContainer>

              <wiz-vgroup gap="0" width="50px" height="100%">
                <wiz-label [wizLabel]="'$.freedata.image.$'" class="componentLabel"></wiz-label>
                <wiz-image
                  #uploadImg
                  tabindex="0"
                  width="50px"
                  height="50px"
                  class="img-picker"
                  [useHandCursor]="true"
                  (click)="clickForUpload()"
                  (keydown)="keydownForUpload($event)"
                ></wiz-image>
              </wiz-vgroup>
              <wiz-icon [visible]="hasImage()" style="cursor: pointer; font-size: 20px" (click)="clearImage()">delete</wiz-icon>

              <wiz-translation-basic
                #trsDesc
                [wizTranslationMode]="'textarea'"
                [maxTranslation]="6"
                [wizLabel]="'$.common.description.$'"
                [wizPlaceholder]="'$.common.define.$'"
                width="260px"
                height="100px"
              ></wiz-translation-basic>

          </wiz-hgroup>

        </wiz-vgroup>

        <!-- chronocode, état, mode -->
        <wiz-vgroup width="180px" gap="5" wizValidationContainer>
              <wiz-dropdown
                #ddChrono
                width="100%"
                [wizLabelField]="'labelAndDates'"
                [wizLabel]="'$.vision.chronocode.main.$'"
                [wizPanelWidth]="'300px'"
                [wizFakeLabel]="'$.vision.chronocode.eon.$'"
              ></wiz-dropdown>
            
              <wiz-dropdown
                #ddStatus
                width="100%"
                [wizLabelField]="'trsLabel'"
                [wizLabel]="'$.bu.home.application.status.$'"
                ></wiz-dropdown>

              <wiz-dropdown
                #ddRunMode
                width="100%"
                [wizLabelField]="'trsLabel'"
                [wizLabel]="'$.bu.home.application.runmode.$'"
                ></wiz-dropdown>
        </wiz-vgroup>

        <!-- couleur de fond, menu web, export PDF -->
        <wiz-vgroup width="130px" gap="5" wizValidationContainer>
          <wiz-vgroup width="130px">
                <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
                <wiz-hgroup verticalAlign="center">
                  <span
                    #blockBack
                    [style.backgroundColor]="backgroundColor"
                    width="20px"
                    height="20px"
                    (click)="showColorPicker($event)"
                    style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
                  ></span>
                  <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
                </wiz-hgroup>
          </wiz-vgroup>
          <wiz-checkbox #cbWebNav wizLabel="$.navigation.web.$"></wiz-checkbox>
          <wiz-checkbox #cbUsePdfExport wizLabel="$.pdfexport.activate.$"></wiz-checkbox>

        </wiz-vgroup>

        <!-- scenarios & compute -->
        <wiz-vgroup width="200px" gap="5" wizValidationContainer>
          <wiz-checkbox #cbUseScen wizLabel="$.scen.activate.$"></wiz-checkbox>
          <wiz-checkbox #cbUseCompute wizLabel="$.use.compute.$"></wiz-checkbox>
          <wiz-checkbox #cbAutoCompute wizLabel="$.autocompute.$" [visible]="!!clone?.useCompute"></wiz-checkbox>
          <wiz-text-input #tiComputeCron width="150px" [wizValidator]="cronValidator()"
          [wizLabel]="'$.compute.cron.$'" [wizShowErrors]="true" [wizMaxChars]=50 [visible]="!!clone?.useCompute"></wiz-text-input>
        </wiz-vgroup>

        <!-- support & aide -->
        <wiz-vgroup width="220px" gap="10" wizValidationContainer>
          <!-- mail du support -->
          <wiz-text-input #tiSupportMail width="100%" wizInputType="email" wizValidator
          [wizLabel]="'$.bu.support.mail.$'" [wizShowErrors]="true" [wizMaxChars]=100></wiz-text-input>

          <!-- url de l'aide en ligne -->
          <wiz-text-input #tiHelpURL width="100%"
          [wizLabel]="'$.bu.support.help.url.$'"  [wizMaxChars]=255></wiz-text-input>
        </wiz-vgroup>

        <!-- plus de conf -->
        <wiz-vgroup width="200px" wizValidationContainer>
          <wiz-text-area #taSettings
            [wizLabel]="'$.mesure.settings.$'"
          ></wiz-text-area>
        </wiz-vgroup>

      </wiz-hgroup>
        
      <!-- boutons d'action -->
      <wiz-vgroup width="200px" height="100%" horizontalAlign="center" verticalAlign="center">
        <wiz-button
          #btnSave
          [wizIcon]="'arrow-right'"
          [wizLabel]="'$.common.save.modification.$'"
          [iconPlacement]="'right'"
          [wizDisabled]="disableButtons"
        ></wiz-button>
        <wiz-button
          #btnCancel
          class="cancel-button"
          [wizIcon]="'arrow-left'"
          [wizLabel]="'$.common.cancel.modification.$'"
          [wizDisabled]="disableCancel"
        ></wiz-button>
      </wiz-vgroup>

    </wiz-hgroup>

      <!-- corps -->
      <wiz-vgroup width="100%" height="100%" style="overflow: auto;">
        <!--panneau de gestion des keys-->
        <wiz-hgroup width="100%" height="400px" class="section-container-parent">
          <!-- liste des freeKeys-->
          <wiz-vgroup width="100%" height="100%" class="section-container">
            <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
              <wiz-icon class="image-purple">key-set</wiz-icon>
              <wiz-label [wizLabel]="'$.vision.free.key.$'" class="titleLabel" width="100%"></wiz-label>
            </wiz-hgroup>
            <wiz-list
              #lstFreeKeys
              width="100%"
              height="100%"
              [wizItemRenderer]="visionKeyRenderer"
              [dragEnabled]="canDragDrop"
              [dropEnabled]="canDragDrop"
              [dragMove]="canDragDrop"
            ></wiz-list>
            <filter-component #lstFreeKeysFilter width="100%"></filter-component>
          </wiz-vgroup>

          <!-- liste des keys -->
          <wiz-vgroup width="100%" height="100%" minHeight="40px" class="section-container">
            <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
              <wiz-icon class="image-purple">key</wiz-icon>
              <wiz-label [wizLabel]="'$.vision.key.$'" class="titleLabel" width="100%"></wiz-label>
            </wiz-hgroup>
            <wiz-list
              #lstKeys
              width="100%"
              height="100%"
              [wizLabelField]="'orderAndlabel'"
              [wizItemRenderer]="orderedVisionKeyRenderer"
              [dragEnabled]="canDragDrop"
              [dropEnabled]="canDragDrop"
              [dragMove]="canDragDrop"
              [enableSelfReorder]="canDragDrop"
              [shopDropIndicator]="canDragDrop"
            >
            </wiz-list>
          </wiz-vgroup>
          <!-- liste des filterKeys -->
          <wiz-vgroup width="100%" height="100%" minHeight="40px" class="section-container">
            <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
              <wiz-icon class="image-purple">filters</wiz-icon>
              <wiz-label [wizLabel]="'$.vision.filter.key.$'" class="titleLabel" width="100%"></wiz-label>
            </wiz-hgroup>
            <wiz-list
              #lstFilterKeys
              width="100%"
              height="100%"
              [wizLabelField]="'label'"
              [wizItemRenderer]="visionKeyRenderer"
              [dragEnabled]="canDragDrop"
              [dropEnabled]="canDragDrop"
              [dragMove]="canDragDrop"
              [enableSelfReorder]="canDragDrop"
              [shopDropIndicator]="canDragDrop"
            ></wiz-list>
          </wiz-vgroup> 
        </wiz-hgroup
        ><!--fin de panneau des Keys-->

        <wiz-hgroup class="section-container-parent"
          wizValidationContainer
          width="100%"
          height="300px"
          style="overflow: auto"
        >
          <ng-container #stepContainer></ng-container>
          <!-- zone d'ajout des steps -->
        </wiz-hgroup>

        <wiz-hgroup width="100%" height="400px" class="section-container-parent">
          <!-- liste des mesures dispo-->
          <wiz-vgroup width="70%" height="100%" class="section-container">
            <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
              <wiz-icon class="image-purple">measure-available</wiz-icon>
              <wiz-label [wizLabel]="'$.vision.free.measure.$'" class="titleLabel" width="100%"></wiz-label>
              <wiz-icon #btnAddAll [wizTooltip]="'$.measure.add.all.$'" tooltipPlacement="right" class="image-back-orange" (click)="doAct('addAllMeasures')">double-arrow-right</wiz-icon>
            </wiz-hgroup>

            <wiz-tile-list
              #lstFreeMeasures
              id="lstFreeMeasures"
              width="100%"
              height="100%"
              class="section-container"
              itemHeight="80"
              itemWidth="220"
              [dragEnabled]="true"
              [dropEnabled]="true"
              [dragMove]="true"
              
              [wizItemRenderer]="measureRenderer"
            ></wiz-tile-list>
            <filter-component #freeMeasureFilter></filter-component>
          </wiz-vgroup>

          <!-- mesures utilisées -->
          <wiz-vgroup width="30%" height="100%" class="section-container">
            <wiz-hgroup width="100%" height="38px" class="widget-header" [verticalAlign]="'center'" padding="10px">
              <wiz-icon class="image-purple">measure</wiz-icon>
              <wiz-label [wizLabel]="'$.vision.measure.$'" class="titleLabel" width="100%"></wiz-label>
              <wiz-icon #btnAddAll [wizTooltip]="'$.measure.remove.all.$'" 
              tooltipPlacement="left" class="image-back-orange" (click)="doAct('removeAllMeasures')">double-arrow-left</wiz-icon>
            </wiz-hgroup>
            <wiz-list
              #lstMeasures
              width="100%"
              height="100%"
              [wizItemRenderer]="measureListRenderer"
              [dragEnabled]="true"
              [dropEnabled]="true"
              [dragMove]="true"
            ></wiz-list><!--  -->
          </wiz-vgroup>
        </wiz-hgroup> </wiz-vgroup
      ><!-- fin de la section détail --> </wiz-vgroup
    ><!-- fin de la partie droite -->
  </wiz-group>
</wiz-h-divider>
